import _ from 'lodash';
import { SortConfiguration } from '../types/rest/paginationTypes';

/**
 * Case-insensitive filter of the list.
 * @param list to be filtered
 * @param searchKeyword to be looked up in the list
 * @param fieldsToSearch attribute names to be searched
 */
export const filterListByKeyword = (list: any[], searchKeyword: string, fieldsToSearch: string[]) => {
  if (!_.isEmpty(searchKeyword)) {
    return list.filter((item: any) => {
      return isObjectContainingString(searchKeyword, item, fieldsToSearch);
    });
  } else {
    return list;
  }
};

/**
 * Applies filtering on a list of elements by name.
 * The search is case-insensitive.
 * @param list list of items to filter
 * @param searchTerm search term
 * @returns filtered list
 */
export const applySearchTermFilterToList = (list: any[], searchTerm: string) => {
  if (!list || !searchTerm) {
    return list;
  }

  return list.filter(item => {
    return item.name.toLowerCase().includes(searchTerm.toLowerCase());
  });
};

/**
 * Applies filtering on a list of elements by id and name and tags attributes. The search
 * is case-insensitive.
 * @param list list of items to filter
 * @param searchTerm search term
 * @returns filtered list
 */
export const applySearchTermFilterToListWithTags = (list: any[], searchTerm: string) => {
  if (!list || !searchTerm) {
    return list;
  }

  const lowerCaseSearchTerm = searchTerm.toLowerCase();

  return list.filter(item => {
    return (
      item.id.toString().includes(lowerCaseSearchTerm) ||
      item.name.toLowerCase().includes(lowerCaseSearchTerm) ||
      (item.tags && _.find(item.tags, tag => tag.toLowerCase().includes(lowerCaseSearchTerm)))
    );
  });
};

/**
 * Case-insensitive search of string in object property values.
 * @param search string to search for
 * @param object
 * @param propertyNames name of properties to be evaluated
 */
export const isObjectContainingString = (search: string, object: any, propertyNames: string[]) => {
  let isContaining = false;
  propertyNames.forEach(property => {
    if (isContaining === true) {
      return;
    }
    if (object[property]) {
      isContaining = String(object[property])
        .toLowerCase()
        .includes(search.toLowerCase());
    }
  });
  return isContaining;
};

export const sortData = (data: any[], sort: SortConfiguration) => {
  //Dont need sorting for just one element
  if (_.size(data) <= 1) {
    return data;
  }
  return _.orderBy(data, sort.sortKey, [sort.direction]);
};
